import { PlusSeparator } from "./Logo";
import { useLang } from "@/i18n/LangContext";

const Row = ({ items }) => (
    <div className="flex shrink-0 items-center" aria-hidden="true">
        {items.map((item, i) => (
            <span key={i} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-mono text-xs font-medium uppercase tracking-[0.28em] text-muted-foreground">
                    {item}
                </span>
                <PlusSeparator className="h-3 w-3 shrink-0" />
            </span>
        ))}
    </div>
);

export const Marquee = () => {
    const { t } = useLang();
    return (
        <div className="overflow-hidden border-y border-border bg-secondary/60 py-4" data-testid="editorial-marquee">
            <div className="marquee-track">
                <Row items={t.marquee} />
                <Row items={t.marquee} />
            </div>
        </div>
    );
};
